var _style, _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamomileTea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9EFE2;}\n\t.st1{fill:#F4A38B;}\n\t.st2{fill:none;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#FFDB00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.8,83.4l-2.27,0.74l-0.82,16.55l1.26,0.67c0,0,3.21,2.55,4.13-4.15c0.14-1,1.02-2.22,1.53-3.04 c1.05-1.68,2.47-3.42,4.4-4.09c1.51-0.53,3.08-0.2,4.42,0.61c4.16,2.5,4.82,6.83,4.06,11.35c-0.68,4.05-2.6,7.8-5.46,10.75 c-4.6,4.75-11.06,7.25-17.4,8.65c-0.65,0.14-1.31,0.28-1.97,0.4c4.17-11.48,7.59-26.41,6.19-42.61h-1.05 c0.93-0.55,1.42-1.11,1.42-1.71c0-3.53-18.05-6.38-40.31-6.38c-22.29,0-40.36,2.85-40.36,6.38c0,0.6,0.5,1.16,1.44,1.71h-1.33 c0,0-3.48,37.47,18.16,66.35c0,0,21.34,10.65,44.83-1.22c0,0,2.15-3.15,4.97-8.62c1.38-0.62,3.76-1.88,7.77-4.39 c0,0,25.92-10.65,28.2-24.07C164.61,107.28,172.1,75.1,142.8,83.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.58,
    y: 77.33,
    className: "st1",
    width: 2.54,
    height: 5.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.7,
    y: 77.36,
    className: "st1",
    width: 2.54,
    height: 12.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.08,123.58c0,0-0.19,0.13-0.45,0.29"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9857 -0.1687 0.1687 0.9857 -14.8471 17.9812)",
    className: "st3",
    cx: 98.4,
    cy: 96.37,
    rx: 3.19,
    ry: 11.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3593 -0.9332 0.9332 0.3593 -22.9358 160.0921)",
    className: "st3",
    cx: 105.13,
    cy: 96.75,
    rx: 11.54,
    ry: 3.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7603 -0.6496 0.6496 0.7603 -38.8215 96.2605)",
    className: "st3",
    cx: 111.02,
    cy: 100.73,
    rx: 11.54,
    ry: 3.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9847 -0.1745 0.1745 0.9847 -16.9152 21.4871)",
    className: "st3",
    cx: 113.76,
    cy: 106.95,
    rx: 11.54,
    ry: 3.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3213 -0.947 0.947 0.3213 -31.0708 184.4877)",
    className: "st3",
    cx: 113.18,
    cy: 113.92,
    rx: 3.19,
    ry: 11.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7784 -0.6278 0.6278 0.7784 -50.6667 95.0932)",
    className: "st3",
    cx: 109.36,
    cy: 119.31,
    rx: 3.19,
    ry: 11.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9877 -0.1564 0.1564 0.9877 -17.8741 17.6051)",
    className: "st3",
    cx: 102.93,
    cy: 122.38,
    rx: 3.19,
    ry: 11.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3709 -0.9287 0.9287 0.3709 -52.6965 166.0355)",
    className: "st3",
    cx: 96.21,
    cy: 121.91,
    rx: 11.54,
    ry: 3.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7683 -0.6401 0.6401 0.7683 -54.501 85.1443)",
    className: "st3",
    cx: 90.37,
    cy: 117.86,
    rx: 11.54,
    ry: 3.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9868 -0.1622 0.1622 0.9868 -16.9397 15.7028)",
    className: "st3",
    cx: 87.71,
    cy: 111.61,
    rx: 11.54,
    ry: 3.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3331 -0.9429 0.9429 0.3331 -39.7317 153.1155)",
    className: "st3",
    cx: 88.38,
    cy: 104.65,
    rx: 3.19,
    ry: 11.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7862 -0.618 0.618 0.7862 -41.6422 78.2528)",
    className: "st3",
    cx: 92.26,
    cy: 99.3,
    rx: 3.19,
    ry: 11.54
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 100.72,
    cy: 109.39,
    r: 6.93
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamomileTea);
export default __webpack_public_path__ + "static/media/Camomile_tea.02a851f393d02f13dc29f263cb7d0ddc.svg";
export { ForwardRef as ReactComponent };